export const APPROVED = 'approved';
export const UNAPPROVED = 'unapproved';
export const FINALIZED = 'finalized';
